export default {
  /* -------------------------------------------------------------------------- */
  /*                             User List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  UserRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create User State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit User State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,

  // for manager

  managersLoading: false,
  managers: []
}
